import { MDSDropdown } from '@marqvision/mds-v2';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useCustomTagsFilter } from './@hooks/useCustomTagFilter';

export const CustomTagsFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const customTagsOptions = useCustomTagsFilter();

  return (
    <MDSDropdown
      label="Tags"
      value={customTagsOptions.selected}
      list={customTagsOptions.list}
      isDisabled={customTagsOptions.disabled}
      isLoading={customTagsOptions.isFetching}
      onChange={(value: any) => customTagsOptions.select(value)}
      modules={[
        'search',
        {
          type: 'filter-button',
          size,
        },
        '1-depth-single',
      ]}
    />
  );
};
